import { Action } from 'redux';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';
import { ToggleBackgroundJobExtendedInfoDialog } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';

export interface ToggleBackgroundJobExtendedInfoDialogAction extends Action {
    backgroundJob: IBackgroundJobInfo;
}

export function toggleBackgroundJobExtendedInfoDialog(
    backgroundJob: IBackgroundJobInfo
): ToggleBackgroundJobExtendedInfoDialogAction {
    return {
        type: ToggleBackgroundJobExtendedInfoDialog,
        backgroundJob,
    };
}

export const isToggleBackgroundJobExtendedInfoDialog = isActionFactory<ToggleBackgroundJobExtendedInfoDialogAction>(ToggleBackgroundJobExtendedInfoDialog);
